import { Component, Input, computed } from '@angular/core';

type ContentType = 'image' | 'video' | 'video-stream' | 'audio' | 'audio-stream' | 'model' | 'text' | 'rich-text' | 'list';

const TYPE_CONFIG: Record<ContentType, { icon: string; color: string; label: string }> = {
  'image':        { icon: '🖼', color: '#4fcdff', label: 'Image' },
  'video':        { icon: '🎬', color: '#ff9b1d', label: 'Video' },
  'video-stream': { icon: '📡', color: '#f472b6', label: 'Stream' },
  'audio':        { icon: '🔊', color: '#4ade80', label: 'Audio' },
  'audio-stream': { icon: '📻', color: '#22d3d8', label: 'Audio Stream' },
  'model':        { icon: '🧊', color: '#892ca3', label: '3D Model' },
  'text':         { icon: '📝', color: '#d0d0d0', label: 'Text' },
  'rich-text':    { icon: '📄', color: '#fbbf24', label: 'Rich Text' },
  'list':         { icon: '📋', color: '#a78bfa', label: 'List' },
};

/**
 * Colored pill that maps a CMS content type (image, video, model, etc.) to an icon and label.
 */
@Component({
  selector: 'es-content-type-badge',
  template: `
    <span
      class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium"
      [style.background]="bgColor()"
      [style.color]="config().color"
    >
      <span>{{ config().icon }}</span>
      {{ config().label }}
    </span>
  `,
})
export class ContentTypeBadgeComponent {
  @Input({ required: true }) type!: ContentType;

  config = computed(() => TYPE_CONFIG[this.type] ?? TYPE_CONFIG['text']);
  bgColor = computed(() => `${this.config().color}22`);
}
